import { useEphattaQuery } from "../../utils/useEphattaQuery"
import { useStaticPageServices } from "./useStaticPageServices"

export const useGetAllStaticPage = (suspense?: boolean) => {
    const service = useStaticPageServices()
    return useEphattaQuery("MiddleOffice.StaticPage", () => service.getAll(), { suspense, refetchOnWindowFocus: false })
} 